import React from 'react';
import './style.scss'
import { useSelector } from 'react-redux';

const CountrySwitcher = () => {

  const country = localStorage.getItem('country')
  const { isLogin , data } = useSelector( state => state?.user)

  if(isLogin){
    localStorage.setItem('country', data?.country)
    return null; // Don't render if the user is logged in
  }
  const handleCountryCode = ()=>{
    return country === 'saudi' ? 'sa' : 'eg'
  }

  const hanldeClick = ()=>{
    window.location.reload()
    localStorage.setItem('country' , country === 'saudi' ? 'egypt' : 'saudi')
  }

  return (
    <div className='CountrySwitcher' onClick={hanldeClick}>
      <span className={`fi fi-${handleCountryCode()}`}></span>
    </div>
  );
}

export default CountrySwitcher;
